import { InitialState, StoreLoadingEnum } from 'src/store/state/types';
import { JobSpec } from './types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import jobSpecApi from './api';

/**
 * Initial State
 */

const initialState: InitialState<{ items: JobSpec[] }> = {
  loading: StoreLoadingEnum.idle,
  error: null,
  data: {
    items: [],
  },
};

/**
 * Async Actions
 */

export const fetchJobSpec = createAsyncThunk('jobSpec', async () => {
  try {
    const PER_PAGE = 100;
    let page = 1;
    let totalCount = 0;
    let jobSpecs: JobSpec[] = [];
    do {
      const response = await jobSpecApi.fetchJobSpec({take: PER_PAGE, page});
      totalCount = response.data.totalCount;
      jobSpecs = [...jobSpecs, ...response.data.items];
      page += 1;
    } while (jobSpecs.length < totalCount);

    return { data: {
      items: jobSpecs,
    }};

  } catch (e) {
    console.error(e);
  }
});

export const jobSpecSlice = createSlice({
  name: 'jobSpec',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobSpec.pending, (state) => {
        state.loading = StoreLoadingEnum.pending;
      })
      .addCase(fetchJobSpec.fulfilled, (state, action) => {
        state.loading = StoreLoadingEnum.succeeded;
        const { data } = action.payload!;
        state.data = data;
      })
      .addCase(fetchJobSpec.rejected, (state) => {
        state.loading = StoreLoadingEnum.failed;
      });
  },
});

export const jobSpecSelector = (state: RootState) => state.jobSpec.data.items;
export const isLoadingSelector = (state: RootState) =>
  state.fileSpec.loading === StoreLoadingEnum.pending;
